/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GenericChannelType = {
    Organic: 'Organic',
    Direct: 'Direct'
} as const;
export type GenericChannelType = typeof GenericChannelType[keyof typeof GenericChannelType];


export function instanceOfGenericChannelType(value: any): boolean {
    for (const key in GenericChannelType) {
        if (Object.prototype.hasOwnProperty.call(GenericChannelType, key)) {
            if (GenericChannelType[key as keyof typeof GenericChannelType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GenericChannelTypeFromJSON(json: any): GenericChannelType {
    return GenericChannelTypeFromJSONTyped(json, false);
}

export function GenericChannelTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenericChannelType {
    return json as GenericChannelType;
}

export function GenericChannelTypeToJSON(value?: GenericChannelType | null): any {
    return value as any;
}

export function GenericChannelTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): GenericChannelType {
    return value as GenericChannelType;
}

